import React from 'react';
import { ArrowRight, Calendar } from 'lucide-react';
import { useContactModal } from '../../contexts/ContactModalContext';
import { BOOKING_URL } from '../../lib/openingHours';

const ReadyToGetStarted: React.FC = () => {
  const { openContactModal } = useContactModal();

  return (
    <section className="w-full py-20 md:py-28 px-6 bg-[#78BE20] text-white">
      <div className="max-w-[900px] mx-auto text-center">
        <h2 className="font-montserrat font-extrabold tracking-[-0.03em] leading-[1.05] text-[clamp(36px,5vw,64px)] mb-4">
          Ready to get started?
        </h2>
        <p className="font-poppins text-white/85 text-base md:text-lg mb-10">
          Talk to our team today and we will help you find the right solution for your project.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            type="button"
            onClick={openContactModal}
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-white text-black font-poppins font-semibold uppercase tracking-[0.12em] text-[11px] hover:bg-black hover:text-white transition-colors"
          >
            Get in touch
            <ArrowRight className="w-4 h-4" />
          </button>

          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-7 py-3.5 border border-white text-white font-poppins font-semibold uppercase tracking-[0.12em] text-[11px] hover:bg-white hover:text-black transition-colors"
          >
            <Calendar className="w-4 h-4" />
            Book a Free Consultation
          </a>
        </div>
      </div>
    </section>
  );
};

export default ReadyToGetStarted;
